import { get, post, del } from '@/shared/api/api-client';
import { injectable } from 'inversify';
import {
  IBusinessOfferDto,
  IBusinessOffersService,
  offersSort,
} from '../types/business-offer';


@injectable()
export class BusinessOffersService implements IBusinessOffersService {
  async getAllBusinesOffers(sort?: offersSort) {
    const res = await get(`${PUBLIC_API_URL}/trades`, {
      'action': sort?.action ? JSON.stringify(sort?.action) : [],
      'active': sort?.active ? JSON.stringify(sort?.active) : [],
      'sorting-direction': sort?.sorting_direction || 'asc',
      'sorting-param': sort?.sorting_param || 'price',
      'agriculture': sort?.agriculture ? JSON.stringify(sort?.agriculture) : []
    });
    return res;
  }

  async getOffersGroup(buyerable_id: number, buyerable_type: string) {
    const res = await get(`${PUBLIC_API_URL}/trades_buyer`, { buyerable_id, buyerable_type });
    return res;
  }

  async getApprovedTrades() {
    const res = await get(`${PUBLIC_API_URL}/trades_ready`);
    return res;
  }

  async getApprovedTradesGroups() {
    const res = await get(`${PUBLIC_API_URL}/trades_group`);
    return res;
  }

  async getTradeById(id: number) {
    const res = await get(`${PUBLIC_API_URL}/trades/${id}`,);
    return res;
  }

  async getCompletedOrders() {
    const res = await get(`${PUBLIC_API_URL}/orders`);
    return res;
  }

  async finishSelectedOrders(tradesArray: number[]) {
    const res = await post(`${PUBLIC_API_URL}/orders`, { trade_id: tradesArray })
    return res;
  } 

  async createBusinessOffer(dto: IBusinessOfferDto) {
    const res = await post(`${PUBLIC_API_URL}/trades`, { ...dto });
    return res;
  }

  async deleteBusinessOffer(id: number, mix_signature?: string) {
    const res = await del(`${PUBLIC_API_URL}/trades/${id}`, true, mix_signature ? { mix_signature }: undefined);
    return res;
  }

  async batchDeleteBusinessOffer(ids: number[]) {
      const idsString = ids.join(',');
      if (!ids || ids.length === 0) return;
      const res = await del(`${PUBLIC_API_URL}/trades/batch_destroy/${idsString}`)
      return res;
  }

  async approveBusinessOffers(ids: number[]): Promise<{ success: boolean }> {
    const res: any = await post(`${PUBLIC_API_URL}/trades_ready`, { trade_ids: ids });
    return res;
  }
}
